import React, { useState } from 'react';
import { useField } from '@unform/core';
import { useDispatch, useSelector } from 'react-redux';

import {
  Card,
  Button,
  TextArea,
  Dropdown,
  TextField,
  WrapperFlex,
} from '@unimed-fesp/components';

import history from '../../../services/history';

function FormEditParametro({ parametro, onBlurValidateInputs }) {
  const { loading } = useSelector((state) => state.parametro);

  const [statusParametrizacao, setStatusParemetrizacao] = useState(
    parametro.ativo ? 'ativo' : 'inativo'
  );
  const [valueParametrizacao, setValueParametrizacao] = useState(
    parametro.valueParametrizacao
  );
  const [descricaoParametrizacao, setDescricaoParametrizacao] = useState(
    parametro.descricao
  );

  const optionsAtividade = [
    { text: 'ativo', onClickOption: () => setStatusParemetrizacao('ativo') },
    {
      text: 'inativo',
      onClickOption: () => setStatusParemetrizacao('inativo'),
    },
  ];

  const onBlurValidation = ({ target }) => {
    const data = {
      valueParametrizacao,
      ativo: statusParametrizacao === 'ativo',
      descricao: descricaoParametrizacao,
    };
    onBlurValidateInputs({
      ...data,
      [target.name]: target.value,
    });
  };
  // #region registrar campos unform
  const {
    registerField: registerFieldValueParametrizacao,
    error: errorValueParametrizacao,
  } = useField('valueParametrizacao');
  const { registerField: registerFieldStatusParametrizacao } = useField(
    'ativo'
  );
  const {
    registerField: registerFieldDescricaoParametrizacao,
    error: errorDescricaoParametrizacao,
  } = useField('descricao');
  // #endregion

  return (
    <WrapperFlex column flex={1} gap={20}>
      <Card margin="0" borderRadius={1}>
        <WrapperFlex
          marginSides={35}
          justifyCenter
          marginTop={30}
          marginBottom={30}
          paddingLeft={144}
          paddingRight={144}
          column
        >
          <TextField
            disabled
            name="nomeParametrizacao"
            labelText="Nome Parametrizacao"
            marginLeft={1}
            marginBottom={30}
            value={parametro.nomeParametrizacao}
            width={640}
          />
          <TextField
            name="valueParametrizacao"
            labelText="Value Parametrizacao"
            marginLeft={1}
            marginBottom={30}
            value={valueParametrizacao}
            onChange={({ target }) => setValueParametrizacao(target.value)}
            width={640}
            register={registerFieldValueParametrizacao}
            error={!!errorValueParametrizacao}
            errorMessage={errorValueParametrizacao}
            onBlur={onBlurValidation}
          />
          <Dropdown
            options={optionsAtividade}
            labelText="Status"
            name="ativo"
            marginLeft={1}
            marginBottom={30}
            width={190}
            register={registerFieldStatusParametrizacao}
          >
            {statusParametrizacao}
          </Dropdown>
          <TextArea
            labelText="Descrição"
            name="descricao"
            marginLeft={1}
            marginBottom={30}
            width={600}
            register={registerFieldDescricaoParametrizacao}
            value={descricaoParametrizacao}
            onChange={({ target }) => setDescricaoParametrizacao(target.value)}
            error={!!errorDescricaoParametrizacao}
            errorMessage={errorDescricaoParametrizacao}
            onBlur={onBlurValidation}
          />
        </WrapperFlex>
      </Card>
      <WrapperFlex justifySpaceBetween>
        <Button
          justifyCenter
          onClick={() => history.push('/novo/parametros')}
          tipo="tertiary"
          width={121}
        >
          cancelar
        </Button>
        <Button
          justifyCenter
          tipo="primary"
          type="submit"
          width={121}
          disabled={
            loading || errorValueParametrizacao || errorDescricaoParametrizacao
          }
        >
          atualizar
        </Button>
      </WrapperFlex>
    </WrapperFlex>
  );
}

export default FormEditParametro;
